import { useMocks } from '../../shared/env';
import type { SubscriptionGateway } from './SubscriptionGateway';
import { HttpSubscriptionGateway } from './HttpSubscriptionGateway';
import { MockSubscriptionGateway } from './MockSubscriptionGateway';

const mockGateway = useMocks ? new MockSubscriptionGateway() : null;

export const subscriptionGateway: SubscriptionGateway = mockGateway ?? new HttpSubscriptionGateway();

/** The mock gateway when (and only when) this build is mock-backed, else null. Used by the mock-only checkout/portal
 * pages and demo controls, which are additionally gated by `mockBillingAffordancesEnabled`. */
export const mockSubscriptionGateway: MockSubscriptionGateway | null = mockGateway;

export type { SubscriptionGateway } from './SubscriptionGateway';
